import React from 'react';
import { useHistory } from 'react-router';
import { Box, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import defaultLocales from 'globals/locales/default';
import Routes from 'routes';
import { TransactionType } from 'globals/types';
import { grey } from 'globals/colors';
import FsIconButton from 'ui-elements/buttons/FsIconButton';
import FsStatusLabel from 'ui-elements/common-elements/FsStatusLabel';
import {
  Value,
  Description,
  Date,
  Name,
  RowBox,
} from './FsExpenditureTableTransactionRow.style-elements';
import {
  getIconButtonBoxStyle,
  getIconStyle,
  getNoTextWrapStyle,
} from './FsExpenditureTableTransactionRow.style';

export interface ChangeCategoryLocationStateProps {
  transaction?: {
    type?: TransactionType;
    id: string;
    name: string;
    date: string;
    displayValue: string;
    category: string;
  };
}

export interface FsExpenditureTableTransactionRowDataProps {
  date: string;
  name: string;
  description: string;
  value: number;
  displayValue: string;
  balance: string;
  tag: string;
  id: string;
  type?: TransactionType;
  category: string;
}

const FsExpenditureTableTransactionRow: React.FC<FsExpenditureTableTransactionRowDataProps> = ({
  id,
  date,
  name,
  description,
  displayValue,
  tag,
  type,
  category,
}) => {
  const iconButtonBoxStyle = getIconButtonBoxStyle();
  const noTextWrapStyle = getNoTextWrapStyle();
  const iconStyle = getIconStyle();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleIconButtonClick = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (): void => {
    handleClose();
    const pathname = Routes.REPORT_MODAL_CHANGE_CATEGORY;
    const state: ChangeCategoryLocationStateProps = {
      transaction: {
        id,
        name,
        date,
        displayValue,
        type,
        category,
      },
    };
    history.push({
      pathname,
      state,
    });
  };

  return (
    <RowBox data-type={type} data-test="single-transaction-row">
      <Box display="flex" flexGrow={1} alignItems="center">
        <Box style={noTextWrapStyle} minWidth={120}>
          <Date>{date}</Date>
        </Box>
        <Box>
          <Name>{name}</Name>
          <Description>{description}</Description>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Box minWidth={100} style={noTextWrapStyle}>
          <FsStatusLabel isFullWidth={false} bgColor={grey.V4} color={grey.V2}>
            {tag}
          </FsStatusLabel>
        </Box>
        <Box minWidth={100} style={noTextWrapStyle}>
          <Value>{displayValue}</Value>
        </Box>
        <Box marginLeft={1}>
          <FsIconButton
            size="small"
            aria-label={defaultLocales.moreInfo}
            onClick={handleIconButtonClick}
            data-test="transaction-contextual-menu-trigger"
          >
            <Box style={iconButtonBoxStyle}>
              <MoreVertIcon style={iconStyle} />
            </Box>
          </FsIconButton>
          <Menu
            data-test="transaction-contextual-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
          >
            <MenuItem
              selected
              onClick={handleMenuItemClick}
              data-test="transaction-contextual-menu-item"
            >
              <span>Change category</span>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </RowBox>
  );
};

export default FsExpenditureTableTransactionRow;
